module.exports = __webpack_public_path__ + "static/brell-8cb899e85503675c9122385f0b8904e0.png";